module.exports = __webpack_public_path__ + "img/005.15b82c32.jpg";